import React from 'react';
import { Box, Alert, Typography } from '@mui/material';
import TopicDetails from '../TopicDetails';

const TopicPreviewWrapper: React.FC = () => {
    return (
        <Box>
            <Alert
                severity="info"
                sx={{
                    borderRadius: 0,
                    mb: 0,
                    borderBottom: '1px solid #e0e0e0',
                    justifyContent: 'center',
                    '& .MuiAlert-message': { width: '100%', textAlign: 'center' }
                }}
            >
                <Typography variant="body2" component="span" fontWeight="bold">
                    Student View Preview Mode:
                </Typography>
                {' '} You are viewing this topic as a student. Progress is not saved.
            </Alert>
            <TopicDetails preview={true} />
        </Box>
    );
};

export default TopicPreviewWrapper;
